import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import type {ActionBarActionEnum} from 'nutshell-graphql-types';

import {getActionOptionRowConfigureLink} from '../helpers';

type Props = {
    label: string;
    actionId: ActionBarActionEnum;
    icon: React.ComponentType<any>;
    isConfigured: boolean;
    handleToggle: () => void;
    isOn: boolean;
    toggleDisabled: boolean;
};

export function ActionOptionRow(props: Props) {
    const {label, icon: Icon, handleToggle} = props;

    return (
        <div className='flex justify-sb pad-8'>
            <Stack isHorizontal={true} spacing={8} alignItems='center'>
                <Icon size={16} wrapWithDiv={false} />
                <Body isBold={true} wrapAnywhere={true}>
                    {label}
                </Body>
            </Stack>
            {props.isConfigured ? (
                <Switch
                    isOn={props.isOn}
                    isRounded={true}
                    onChange={handleToggle}
                    isDisabled={props.toggleDisabled}
                />
            ) : (
                getActionOptionRowConfigureLink(props.actionId)
            )}
        </div>
    );
}
